(function () {
  function initResourceRoot(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-resource-card]'));
    var search = root.querySelector('[data-resource-search]');
    var sort = root.querySelector('[data-resource-sort]');
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-resource-filter]'));
    var loadMore = root.querySelector('[data-resource-load-more]');
    var count = root.querySelector('[data-resource-count]');
    var results = root.querySelector('[data-resource-results]');
    var grid = root.querySelector('[data-resource-grid]');
    var visible = 9;
    var activeType = 'all';
    var query = '';

    if (!cards.length || !grid) return;

    function matchingCards() {
      var filtered = cards.filter(function (card) {
        var typeMatch = activeType === 'all' || card.dataset.type === activeType;
        var title = (card.dataset.title || '').toLowerCase();
        var searchMatch = !query || title.indexOf(query) !== -1;
        return typeMatch && searchMatch;
      });

      var mode = sort ? sort.value : 'newest';
      filtered.sort(function (a, b) {
        if (mode === 'az') return (a.dataset.title || '').localeCompare(b.dataset.title || '');
        if (mode === 'most-read') return Number(b.dataset.readCount || 0) - Number(a.dataset.readCount || 0);
        return Number(b.dataset.date || 0) - Number(a.dataset.date || 0);
      });

      return filtered;
    }

    function render() {
      var filtered = matchingCards();
      cards.forEach(function (card) { card.hidden = true; });
      filtered.forEach(function (card, index) {
        card.hidden = index >= visible;
        grid.appendChild(card);
      });

      if (count) {
        count.textContent = 'Showing ' + Math.min(visible, filtered.length) + ' of ' + filtered.length + ' guides';
      }
      if (loadMore) loadMore.hidden = filtered.length <= visible;
      if (results) {
        if (query) {
          results.hidden = false;
          results.textContent = filtered.length + (filtered.length === 1 ? ' guide' : ' guides') + ' matching "' + query + '"';
        } else {
          results.hidden = true;
          results.textContent = '';
        }
      }
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        activeType = pill.dataset.resourceFilter || 'all';
        visible = 9;
        pills.forEach(function (candidate) { candidate.classList.toggle('is-active', candidate === pill); });
        render();
      });
    });

    if (search) {
      search.addEventListener('input', function () {
        query = search.value.trim().toLowerCase();
        visible = 9;
        render();
      });
    }

    if (sort) {
      var hasReadCounts = cards.some(function (card) { return Number(card.dataset.readCount || 0) > 0; });
      var mostRead = sort.querySelector('option[value="most-read"]');
      if (!hasReadCounts && mostRead) mostRead.hidden = true;
      sort.addEventListener('change', render);
    }

    if (loadMore) {
      loadMore.addEventListener('click', function () {
        visible += 6;
        render();
      });
    }

    render();
  }

  function initFaq(scope) {
    scope.querySelectorAll('[data-resource-faq]').forEach(function (faq) {
      faq.querySelectorAll('.rh-faq__question').forEach(function (button) {
        button.addEventListener('click', function () {
          var answer = button.parentElement.querySelector('.rh-faq__answer');
          var isOpen = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          if (answer) answer.hidden = isOpen;
        });
      });
    });
  }

  function initToc(scope) {
    var prose = scope.querySelector('[data-resource-prose]');
    var toc = scope.querySelector('[data-resource-toc]');
    if (!prose || !toc) return;

    var headings = Array.prototype.slice.call(prose.querySelectorAll('h2'));
    headings.forEach(function (heading, index) {
      if (!heading.id) heading.id = 'resource-section-' + (index + 1);
      var link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent;
      link.addEventListener('click', function (event) {
        event.preventDefault();
        heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      toc.appendChild(link);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-resource-root]').forEach(initResourceRoot);
    initFaq(document);
    initToc(document);
  });
})();
